@import 'styles/variables';

.menu {
  min-width: 250px;
}

.integrationItemContainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.integrationItem {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 5px 0;
}

.integrationDetails {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.avatarWithStatus {
  display: flex;
  align-items: center;
  position: relative;
}

.alertOverlay {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.errorOverlay {
  background: var(--red-50);

  [data-autopilot-system-redesign='on'] & {
    background: var(--red-90);
  }
}

.reauthOverlay {
  background: var(--red-50);

  [data-autopilot-system-redesign='on'] & {
    background: var(--red-50);
    padding-bottom: 1px;
  }
}

.warningOverlay {
  background: var(--yellow-50);
}

.successOverlay {
  background: var(--green-50);
}

.addNewAccountItem {
  display: flex;
  align-items: center;
  padding: 4px 0;
  gap: 12px;
}
